import React from "react";
import {reactCreateMemo} from "@wix/devzai-utils-react";
import {DoppeHideableValue, doppeHideableValueIsVisible} from "../../client-server-common/types/doppe-hideable-value";

export const DoppeHideableValueRenderer = reactCreateMemo(function DoppeHideableValueRenderer<V> (
    props: {
        hideableValue: DoppeHideableValue<V>;
        renderFunction: (value: V) => React.ReactElement | null;
    }
) {

    const {
        hideableValue,
        renderFunction
    } = props;

    return doppeHideableValueIsVisible<V>(hideableValue) ? renderFunction(hideableValue) : null;
})